import { Notification } from '@builddocs/mui'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import type { DialogProps } from '@mui/material/Dialog'

export function NotificationModal({
  message,
  onOk,
  okText,
  cancelText,
  closeText,
  title,
  ...rest
}: Omit<DialogProps, 'onOk'> & {
  message: string
  onOk?: () => void
  okText?: string
  cancelText?: string
  closeText?: string
}) {
  return (
    <Dialog {...rest}>
      <DialogTitle>{title ?? 'Продолжить?'}</DialogTitle>
      <DialogContent>
        <Notification message={message} />
      </DialogContent>
      <DialogActions>
        {onOk ? (
          <>
            {/* @ts-expect-error обязательные, но не обязательные аргументы */}
            <Button variant="outlined" onClick={() => rest.onClose?.()}>
              {cancelText ?? 'Нет'}
            </Button>
            <Button autoFocus variant="contained" onClick={onOk}>
              {okText ?? 'Да'}
            </Button>
          </>
        ) : (
          /* @ts-expect-error обязательные, но не обязательные аргументы */
          <Button variant="outlined" onClick={() => rest.onClose?.()}>
            {closeText ?? 'Понятно'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
